module.exports = __webpack_public_path__ + "img/cargo-wagon-shadow-4.600618f3.png";